import React from 'react'
import {Link} from 'react-router'


export default class PgyMallCard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            show: true
        }
    }

    componentWillMount() {
        let day = this.handleRetrunDay();
        if(localStorage.getItem('wkMallBarStu') === day){
            this.setState({show: false});
        }
    }

    handleCloseWeekBar(){
        this.setState({
            show:false
        });
        let day = this.handleRetrunDay();
        localStorage.setItem('wkMallBarStu', day);
    }

    handleRetrunDay() {
        //按天存储
        let date = new Date(),
            year = date.getFullYear(),
            month = date.getMonth() + 1,
            day = date.getDate();
        return year.toString() + month + day;
    }

    render() {
        const {show} = this.state;
        if (!show) {
            return null;
        }

        return (
            <Link to="/specials/activity/pgy_mall?fr=student" className="liveroom-mall-bar" style={{marginBottom: '-10px', display: 'block', position:'relative', marginTop: this.props.isTop ? "-10px" : '0'}}>
                <span className="close" onClick={(e) => {e.preventDefault(); this.handleCloseWeekBar();}} style={{position: 'absolute',width:'18px',height:'18px',right:'17px',top:'17px',padding:'3px'}}>
                    <img src='https://static-cos.lycheer.net/xupload/20180921_close.png' alt=""/>
                </span>
                <img src="https://static-cos.lycheer.net/picture/7832811_9abd54a18867c6d3db55f051cbcea653.jpg"/>
            </Link>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/activity/PgyMallCard.js